import { z } from 'zod';
import { paginationQueryFor } from '../common/pagination.js';
export const userStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);
export const createUserSchema = z.object({
    employeeId: z.string().optional(),
    nameAr: z.string().trim().min(1).max(120).optional(),
    nameEn: z.string().trim().min(1).max(120).optional(),
    username: z.string().trim().min(1).max(64),
    email: z.email().optional(),
    phone: z.string().trim().max(32).optional(),
    nfcId: z.string().trim().max(64).optional(),
    groupId: z.string().min(1),
    branchIds: z.array(z.string()).min(1),
});
export const updateUserSchema = z.object({
    nameAr: z.string().trim().min(1).max(120).optional(),
    nameEn: z.string().trim().min(1).max(120).optional(),
    email: z.email().optional(),
    phone: z.string().trim().max(32).optional(),
    groupId: z.string().min(1).optional(),
    branchIds: z.array(z.string()).min(1).optional(),
});
export const changeUserStatusSchema = z.object({ status: userStatusSchema });
export const userListQuerySchema = paginationQueryFor([
    'id',
    'username',
    'nameAr',
    'nameEn',
    'email',
    'groupId',
    'status',
    'lastLoginAt',
    'createdAt',
    'updatedAt',
]).extend({
    status: userStatusSchema.optional(),
    groupId: z.string().optional(),
});
export const employeeLookupQuerySchema = z.object({ username: z.string().trim().min(1) });
//# sourceMappingURL=contract.js.map